import React from "react";

const Close = () => {
  return (
    <svg
      width="6"
      height="5"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.32227 12.3408C1.7002 12.7188 2.3418 12.71 2.71094 12.3408L7 8.06055L11.2803 12.3408C11.6494 12.71 12.291 12.7188 12.6689 12.3408C13.0469 11.9629 13.0381 11.3213 12.6689 10.9521L8.38867 6.66309L12.6689 2.38281C13.0381 2.01367 13.0469 1.37207 12.6689 0.994141C12.291 0.616211 11.6494 0.625 11.2803 0.994141L7 5.27441L2.71094 0.985352C2.3418 0.625 1.7002 0.616211 1.32227 0.994141C0.944336 1.37207 0.953125 2.01367 1.32227 2.38281L5.60254 6.66309L1.32227 10.9521C0.953125 11.3213 0.944336 11.9629 1.32227 12.3408Z"
        fill="#797979"
      />
    </svg>
  );
};

export default Close;
